import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExpenseFormModel } from './expenseform.model';
import { AccountsAndTaxesModel } from './accountsandtaxes.model';
import { ContactModel } from '../../contact/contact/contact.model';
import { ContactService } from '../../contact/contact/contact.service';
import { ExpenseService } from './expense.service';
import { UserContactService } from '../../user/usercontact/usercontact.service';
import { UserCompanyService } from '../../user/usercompany/usercompany.service';
import { BankAccountModel } from '../../finanzas/bancos/bankaccount.model';
import { BankAccountService } from '../../finanzas/bancos/bankaccount.service';
import { InvoiceLineModel } from './invoiceline.model';
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { ExpenseClassificationService } from './expense-classification.service';

@Component({
    selector: 'convfact-expense',
    templateUrl: './expense.component.html',
    styleUrls: ['./expense.component.css'],
    standalone: false
})
export class ExpenseComponent implements OnInit {
  preinvoice = new ExpenseFormModel();
  contacts: ContactModel[] = [];
  accountsAndTaxes = new AccountsAndTaxesModel();
  bankAccounts: BankAccountModel[] = [];
  errors = {};
  isDataAvaible: boolean = false;
  ready = false;

  submit(): void {}

  constructor(
    private expenseService: ExpenseService,
    private contactService: ContactService,
    private userContactService: UserContactService,
    private userCompanyService: UserCompanyService,
    private bankAccountService: BankAccountService,
    private route: ActivatedRoute,
    private router: Router,
    private expenseClassificationService: ExpenseClassificationService,
    public snackBar: MatSnackBar
  ) {}

  // Clasificación por concepto (línea): matchea por posición entre las líneas originales
  // (con lo que el usuario eligió en los desplegables) y las líneas devueltas por el guardado
  // (con el id real, que solo existe una vez guardadas).
  private saveClasificadorIfNeeded(savedPreinvoice: any, originalPreinvoice: any): void {
    if (!savedPreinvoice.invoiceLines || !originalPreinvoice.invoiceLines) return;

    const lines = savedPreinvoice.invoiceLines
      .map((savedLine, i) => {
        const originalLine = originalPreinvoice.invoiceLines[i];
        if (!originalLine || !originalLine.clasificadorPartida || !savedLine.id) return null;
        return {
          invoiceLineId: savedLine.id,
          partida: originalLine.clasificadorPartida,
          subpartida: originalLine.clasificadorSubpartida,
          familia: originalLine.clasificadorFamilia,
        };
      })
      .filter(l => l !== null);

    if (lines.length > 0) {
      this.expenseClassificationService.setClassificationsByInvoice(savedPreinvoice.uid, lines);
    }
  }

  displayInfo(response: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10500;
    this.snackBar.open(response, '', options);
  }

  public saveData(preinvoice): void {
    if (preinvoice.uid == null || preinvoice.uid == undefined) {
      preinvoice.publish = true;
      preinvoice.isReceptor = true;

      this.expenseService.addData(preinvoice)
        .then(savedPreinvoice => {
          this.preinvoice = savedPreinvoice;
          this.saveClasificadorIfNeeded(savedPreinvoice, preinvoice);
          this.expenseService.saveRequestUpdateValue(false);
          this.returnToIndex();
        })
        .catch(errors => {
          this.expenseService.saveRequestUpdateValue(false);
          if (errors && errors.error && errors.error.message) {
            this.displayInfo(errors.error.message);
          } else {
            this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
          }
        });
    } else {
      this.expenseService.editData(preinvoice.uid, preinvoice)
        .then(savedPreinvoice => {
          this.preinvoice = savedPreinvoice;
          this.saveClasificadorIfNeeded(savedPreinvoice, preinvoice);
          this.expenseService.saveRequestUpdateValue(false);
          this.returnToIndex();
        })
        .catch(errors => {
          this.expenseService.saveRequestUpdateValue(false);
          if (errors && errors.error && errors.error.message) {
            this.displayInfo(errors.error.message);
          } else {
            this.displayInfo('Compruebe los campos obligatorios marcados en rojo');
          }
        });
    }
  }

  ngOnInit(): void {
    this.preinvoice.invoiceLines = new Array<InvoiceLineModel>();
    this.preinvoice.invoiceLines.push(new InvoiceLineModel());

    this.bankAccountService.getList().then(bankAccounts => {
      this.bankAccounts = bankAccounts.list;
    });

    this.expenseService.accountsAndTaxesData().then(accountsAndTaxes => {
      this.accountsAndTaxes = accountsAndTaxes;
    });

    this.contactService.getListProviders().then(contacts => {
      this.contacts = contacts;
      this.isDataAvaible = true;
    });

    this.route.params.subscribe(params => {
      const uid = params['uid'];
      if (uid != null) {
        Promise.all([
          this.expenseService.loadData(uid),
          this.expenseClassificationService.getClassificationsByInvoice(uid).catch(() => [])
        ]).then(([preinvoice, classifications]) => {
          this.preinvoice = preinvoice;

          (classifications || []).forEach(c => {
            const line = this.preinvoice.invoiceLines.find(l => l.id === c.invoiceLineId);
            if (line) {
              line.clasificadorPartida = c.partida;
              line.clasificadorSubpartida = c.subpartida;
              line.clasificadorFamilia = c.familia;
            }
          });

          this.ready = true;
        }).catch(err => {
          this.displayInfo(err['error']['message']);
          this.returnToIndex();
        });
      } else {
        this.preinvoice.invoiceRelease = new Date();
        this.preinvoice.fiscalYear = new Date().getFullYear();
        this.preinvoice.invoiceLines = new Array<InvoiceLineModel>();
        this.preinvoice.invoiceLines.push(new InvoiceLineModel());

        this.userContactService.loadData().then(userContact => {
          this.preinvoice.receiverAddress = userContact.address;
          this.preinvoice.receiverPostalCode = userContact.postalCode;
          this.preinvoice.receiverLocation = userContact.location;
          this.preinvoice.receiverCountry = userContact.country;
          this.preinvoice.receiverState = userContact.state;
        });

        this.userCompanyService.loadData().then(userCompany => {
          this.preinvoice.receiverName = userCompany.companyName;
          this.preinvoice.receiverVatNumber = userCompany.vatNumber;
        });

        this.ready = true;
      }
    });
  }

  returnToIndex(): void {
    this.router.navigate(['/expense/list']);
  }
}